import { lowerCaseFirstLetter } from "@/utils";
import { QueryTypeEnum } from "@graphapi-io/declarations";
import { gql } from "apollo-boost";
import { ApiFields } from "../shared/api-fields";
import {
  FieldNameComposer,
  FieldParameterTypeEnum,
} from "../shared/fieldname-composer";

export abstract class GqlDedicatedQueryComposer {
  public static buildObjectQuery(typeName: string, fields: ApiFields) {
    const fieldName = FieldNameComposer.fieldNameForQueryType(
      QueryTypeEnum.OBJECT,
      typeName,
    );

    return gql`
      query ${fieldName}($id: ID!) {
        ${fieldName}(id: $id) {
          ${fields.getNonObjectFieldsForObjectType(typeName).join("\n")}
        }
      }
    `;
  }

  public static buildListQuery(typeName: string, fields: ApiFields) {
    const fieldName = FieldNameComposer.fieldNameForQueryType(
      QueryTypeEnum.LIST,
      typeName,
    );

    return gql`
      query ${fieldName}($limit: Int, $nextToken: String, $filter: ${FieldNameComposer.inputNameForType(
        FieldParameterTypeEnum.FILTER,
        typeName,
      )}, $sortOrder: SortOrderType, $sortRange: RangeComparisonInput) {
        ${fieldName}(limit: $limit, nextToken: $nextToken, filter: $filter, sortOrder: $sortOrder, sortRange: $sortRange) {
          nextToken
          items {
            ${fields.getNonObjectFieldsForObjectType(typeName).join("\n")}
          }
        }
      }
    `;
  }

  public static buildListByQuery(
    typeName: string,
    parentName: string,
    fields?: string[],
  ) {
    const fieldName = FieldNameComposer.fieldNameForListByParentType(
      typeName,
      parentName,
    );
    const parentIdField = `${lowerCaseFirstLetter(parentName)}Id`;

    return gql`
      query ${fieldName}($id: ID!, $limit: Int, $nextToken: String, $filter: ${FieldNameComposer.inputNameForType(
        FieldParameterTypeEnum.FILTER,
        typeName,
      )}, $sortOrder: SortOrderType, $sortRange: RangeComparisonInput) {
        ${fieldName}(${parentIdField}: $id, limit: $limit, nextToken: $nextToken, filter: $filter, sortOrder: $sortOrder, sortRange: $sortRange) {
          nextToken
          items {
            id
            ${(fields ?? []).join("\n")}
          }
        }
      }
    `;
  }
}
